/**
 * Sefersiz raporlar, sefer bağları ve ofisin sefer talebi metinleri (aşama V3; ADR 0083; ortağın
 * `sefer-3.jpeg`, `sefer-5.jpeg`, `sefer-6.jpeg`). Ekran adları İngilizce; Türkçe ikinci dil.
 */

export const voyageLinksEn = {
  suggestions: {
    title: 'Suggested Reports',
    description:
      'Reports entered without a voyage that fit this voyage, in date order. Nothing is linked until you confirm.',
    select: 'Select {{no}}',
    selectAll: 'Select all',
    link: 'Link Selected ({{count}})',
    request: 'Request Link ({{count}})',
    linked: '{{count}} report(s) linked.',
    requested: 'Link request sent to the vessel.',
    none: 'No reports without a voyage to suggest.',
  },
  linked: {
    source: {
      manual: 'Linked',
      office: 'Linked by office',
      migrated: 'Linked (earlier departure)',
    },
    unlink: 'Unlink',
    unlinkTitle: 'Unlink {{no}}',
    unlinked: 'Report unlinked; it is again without a voyage.',
    requestUnlink: 'Request unlink',
    unlinkRequested: 'Unlink request sent to the vessel.',
  },
  requests: {
    title: 'Office Voyage Requests',
    description:
      'The office opens voyages and links reports by request; the vessel applies or rejects them.',
    action: {
      create_voyage: 'Open voyage {{no}}',
      link: 'Link {{count}} report(s) to {{no}}',
      unlink: 'Unlink {{count}} report(s) from {{no}}',
    },
    status: { pending: 'Pending', applied: 'Applied', rejected: 'Rejected' },
    by: 'Requested by {{name}} · {{at}}',
    decided: 'Decided by {{name}} · {{at}}',
    accept: 'Apply',
    reject: 'Reject',
    rejectTitle: 'Reject request',
    reason: 'Reason',
    reasonHint: 'The office sees the reason.',
    cancel: 'Cancel',
    applied: 'Request applied.',
    rejectedDone: 'Request rejected.',
    empty: 'No voyage requests.',
    unknownVoyage: 'voyage',
  },
};

export const voyageLinksTr: typeof voyageLinksEn = {
  suggestions: {
    title: 'Önerilen Raporlar',
    description:
      'Sefersiz girilmiş ve bu sefere uyan raporlar, tarih sırasıyla. Onaylamadan hiçbiri bağlanmaz.',
    select: '{{no}} seç',
    selectAll: 'Hepsini seç',
    link: 'Seçilenleri Bağla ({{count}})',
    request: 'Bağlama Talebi ({{count}})',
    linked: '{{count}} rapor bağlandı.',
    requested: 'Bağlama talebi gemiye gönderildi.',
    none: 'Önerilecek sefersiz rapor yok.',
  },
  linked: {
    source: { manual: 'Bağlı', office: 'Ofis bağladı', migrated: 'Bağlı (eski kalkış)' },
    unlink: 'Bağı çöz',
    unlinkTitle: '{{no}} bağını çöz',
    unlinked: 'Bağ çözüldü; rapor yeniden sefersiz.',
    requestUnlink: 'Çözme talebi',
    unlinkRequested: 'Çözme talebi gemiye gönderildi.',
  },
  requests: {
    title: 'Ofisin Sefer Talepleri',
    description:
      'Ofis seferi açar ve raporları talep olarak bağlar; gemi uygular ya da gerekçeyle reddeder.',
    action: {
      create_voyage: '{{no}} seferini aç',
      link: '{{count}} raporu {{no}} seferine bağla',
      unlink: '{{count}} raporun {{no}} bağını çöz',
    },
    status: { pending: 'Bekliyor', applied: 'Uygulandı', rejected: 'Reddedildi' },
    by: 'Talep eden {{name}} · {{at}}',
    decided: 'Karar veren {{name}} · {{at}}',
    accept: 'Uygula',
    reject: 'Reddet',
    rejectTitle: 'Talebi reddet',
    reason: 'Gerekçe',
    reasonHint: 'Ofis gerekçeyi görür.',
    cancel: 'Vazgeç',
    applied: 'Talep uygulandı.',
    rejectedDone: 'Talep reddedildi.',
    empty: 'Sefer talebi yok.',
    unknownVoyage: 'sefer',
  },
};
